var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStyling(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_styling_svg__clip0_3558_64)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.89 1.261a.322.322 0 01.227-.094h2.488v1.048l-1.566 1.47a.5.5 0 00.342.864H7.83a.5.5 0 00.342-.865l-1.567-1.47V1.168h4.017v1.048l-1.567 1.47a.565.565 0 00-.157.344l-.334 7.28a.5.5 0 00.5.523h4.107a.5.5 0 00.5-.523l-.33-7.183c0-.299-.152-.442-.152-.442l-1.567-1.47V1.168h2.264a.322.322 0 01.322.322L14.53 15h-.95v1H16.5v-1h-.97l-.321-13.518A1.323 1.323 0 0013.886.167H3.117a1.322 1.322 0 00-1.322 1.315L1.474 15H.5v1h2.921v-1h-.947l.32-13.5V1.49c0-.086.035-.168.095-.228zm2.755 2.288l.46-.432.461.432h-.921zm5.016 0l.461-.432.46.432h-.92zm-.786 1l-.288 6.283h1.032V4.55h-.744zm1.744 6.283h1.029l-.289-6.283h-.74v6.283z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_styling_svg__clip0_3558_64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgIcStyling;